import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	Img,
	Text,
	Link,
	OrderedList,
	ListItem,
	UnorderedList,
} from "@chakra-ui/react";

const linkedInUrl = "https://www.linkedin.com/in/ramesh-kannan-80627aa/";
const fileUrl =
	"https://somersetinduscap.com/wp-content/uploads/2023/10/Sustainability-and-Impact-Report_Somerset-Indus-Capital_March-2023.pdf";

const FundInFocusIndusHealth = () => (
	<>
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "450px", sm: "300px" }}
			minH={{ xs: "450px", sm: "300px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir="column"
				px={{ xs: "20px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Heading
					as="h1"
					mb="20px"
					variant="reportCardTitle"
					fontSize={{ xs: "26px", sm: "28px", md: "32px", lg: "38px" }}
					color="white"
					lineHeight={{ xs: "34px", md: "39px", lg: "42px" }}
				>
					FUND IN FOCUS: Somerset Indus Healthcare Fund - Leading the Charge in
					Indian Healthcare Investments
				</Heading>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			{/* https://www.linkedin.com/in/ramesh-kannan-80627aa/ */}
			<Box as="main" w="100%" pb="40px">
				<Text variant="`blogAnswer`">
					Welcome to our ‘Fund in Focus’ series where we profile our member
					funds, underscore their investment philosophy, and highlight some of
					their interesting work. Today we speak to{" "}
					<Link
						href={linkedInUrl}
						target="_blank"
						style={{
							textDecoration: "underline",
						}}
						rel="noreferrer"
					>
						Ramesh Kannan
					</Link>{" "}
					, Senior partner, Somerset Indus Healthcare Fund - a distinguished
					private equity firm, showcases its commitment to revolutionizing the
					healthcare landscape in India. With a laser focus on healthcare, their
					investment strategies are strategically aligned with three core
					sectors: Hospitals, Diagnostics, and Labs; Pharmaceuticals and Life
					Sciences; and Medtech Manufacturing. Somerset Indus stands out from
					competitors by emphasizing conservative valuations, exclusive
					partnerships with promising promoters, and meticulous post-investment
					support. Their success stories include enabling accessibility to
					critical healthcare services in underserved regions, fostering
					innovation in medical technology, and driving sustainable impact
					through adherence to environmental, social, and governance standards.
				</Text>
			</Box>

			{/* <Box
          backgroundImage={`url('https://static.levocdn.com/WGLBUT82/PictureRamesh-Kanan-oiljrVjkKKWo.png')`}
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
          mb="20px"
          width="300px"
          height="300px"
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          rounded="full"
        ></Box> */}

			<Img
				src="https://static.levocdn.com/WGLBUT82/PictureRamesh-Kanan-oiljrVjkKKWo.png"
				alt="Apoorva"
				boxSize="300px"
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "70px" }}
				mb="20px"
				objectFit="cover"
				rounded="full"
			/>
			<Flex flexDir={{ xs: "column", lg: "row" }} rowGap="16px">
				<Heading
					textAlign={{ xs: "center", md: "left" }}
					fontWeight="800"
					color="blue.400"
				>
					Spokesperson: Ramesh Kannan, Senior partner, Somerset Indus Healthcare
					Fund
				</Heading>
			</Flex>
			<Box>
				<Box
					ml={{ xs: "auto", md: "345px", lg: "370px" }}
					mr={{ xs: "auto", md: "0px" }}
					width={{ xs: "160px", md: "80px" }}
					h="2px"
					bgColor="primary.500"
					borderRadius="5px"
					mt={{ xs: "16px", md: "10px" }}
					mb="15px"
				/>
				<Box mt="16px" mb="20px">
					<Heading variant="blogQuestion" mb="20px">
						1. Could you provide insights into Somerset Indus Healthcare Fund’s
						investment focus within the healthcare sector in India?
					</Heading>
					<Text variant="blogAnswer">
						Somerset Indus healthcare fund focuses exclusively on healthcare, we
						have completed two funds and right now engaged in raising $250mn for
						our fund III. We invested in seven companies from our Fund I and
						another set of seven companies from our fund II.
						<br />
						<br />
						Fund I saw investments in –{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Sandor Medicads
						</Text>{" "}
						(ICU distribution),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Krsnaa Diagnostics
						</Text>{" "}
						(PPP diagnostics),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Ujala Hospitals
						</Text>{" "}
						(in tier II and III cities),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Browndove
						</Text>{" "}
						(renal care consumable company),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Prognosys
						</Text>{" "}
						(manufacturer of medical equipment), (renal care consumable
						company),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Chaya Graphics
						</Text>{" "}
						(medical consumable distribution), (renal care consumable company),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Hexagon Nutrition
						</Text>{" "}
						(research-oriented organization engaged in formulating,
						nutraceutical products).
						<br />
						<br />
						Our fund II saw us investing in{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Genworks
						</Text>{" "}
						(medical equipment and consumable distribution company focused on
						tier 2 and tier 3 cities promoted by GE and Wipro),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Apex Hospitals
						</Text>{" "}
						(a hospital in Jaipur growing),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Globela Pharma
						</Text>{" "}
						(a Pharma formulation company getting into API),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Sterling Hospitals
						</Text>{" "}
						(oncology hospital chain into tier 2 and tier 3 cities),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							EMIL Pharma
						</Text>{" "}
						(a pharmaceutical formulation- generic products focused in Latin
						American markets),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Natural Biogenex
						</Text>{" "}
						(hormones and steroids),{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Printmann
						</Text>{" "}
						(pharmaceutical packaging with technology as a key component)
					</Text>
					<br />
					<br />
					<Text as="span" variant="blogQuestion" fontWeight="700">
						Essentially Somerset operates in 3 buckets:
					</Text>{" "}
					<OrderedList>
						<ListItem>
							<Text variant="blogAnswer" as="span">
								Hospitals, Diagnostics and Labs
							</Text>
						</ListItem>
						<ListItem>
							<Text variant="blogAnswer" as="span">
								Pharmaceuticals (including API) and Life Sciences
							</Text>
						</ListItem>
						<ListItem>
							<Text variant="blogAnswer" as="span">
								Medtech including manufacturing
							</Text>
						</ListItem>
					</OrderedList>
					<br />
					<br />
					The last bucket is an assorted one which includes biomedical services,
					nutrition’s manufacturing, preventive care etc.
				</Box>
				{/* Question 2 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pb="20px" pt="12px">
						2. What sets Somerset Indus apart from other private equity firms
						operating in the Indian healthcare space?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						In today’s context money is available everywhere and plentiful too.
						Valuations are high in many cases, money gets used indiscriminately
						to garner revenue and market share and funds are competing to get
						investments resulting in a valuation war.
					</Text>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Somerset operates at a different level. Its valuation is
						conservative, it does not participate in auctions, if it likes the
						promoters and the business, it seeks exclusivity. We work together
						with the promoter in building the business plan. We are open to
						offering a clawback if the promoters perform and ultimately it
						provides value, thanks to the domain expertise it offers. In
						addition, we help our investee companies finding the right people at
						CXO level to pursue business opportunities. The fund also helps in
						identifying targets for acquisition, and bringing on board foreign
						director from our LP’s to provide a global perspective to the
						portfolio company. In addition there are lot of emphasis in
						monitoring, course correction, and a strong reliance on compliance,
						governance, MIS, reviews etc. So ultimately even in spite of a
						conservative valuation companies come to us because of the sheer
						value we create resulting in higher valuation in the future.
					</Text>
				</Box>

				{/* Question 3 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="28px">
						3. How does Somerset Indus plan to utilize the capital commitment
						from domestic institutional investors for its third private equity
						fund, and what are the fund's growth expectations and timelines?
					</Heading>
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Fund III is a $250mn fund, with marquee investors from the domestic
						as well as global markets. We expect to raise the fund by the end of
						this year with multiple closures beginning two months from now. All
						our investors are very impressed with our performance and focus on
						developing and building a very robust healthcare system in India.
						<br />
						<br />
						We will continue to invest in healthcare only and considering
						increase in the requirement of the portfolio companies for growth,
						expansion, diversification, and acquisition we also have co
						investment rights with select LP’s.
						<br />
						<br />
						On our own we can invest up to $25mn per investment and seek
						co-investment as required if the asking amount is more. We will
						continue to do seven more investments from this fund.
						<br />
						<br />
						We believe that in line with the performance of Fund I where we will
						exit 100%, no loss, very good IRR, DPI and MOIC, the trend will
						continue in fund II and in fund III as well
					</Text>
				</Box>

				{/* Question 4 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						4. How does Somerset Indus evaluate potential investment
						opportunities in healthcare delivery product and service platforms?
						What criteria do you prioritize?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Our fundamental and most important criteria is the promoter. We
						spend a lot of time in understanding and providing support to
						promoters even prior to investments to get a perspective on how they
						act or operate. For us a good promoter and a bad business can be
						rectified and not the other way around.
						<br />
						<br />
						The second criteria is integrity and compliance, governance and the
						ability to adhere to ESG norms. We are extremely particular about
						these factors and these are sacrosanct. Third, we understand very
						clearly the way forward both in terms, merger and acquisitions and
						exit - this is extremely important to avoid any misunderstanding
						later.
						<br />
						<br />
						We do not invest in health-tech and invest only in healthcare and
						require both top line and bottom line with a robust PBT and a
						potential to expand and grow both within and outside the country
						<br />
						<br />
						In Fund III, we want to invest in a oncology equipment manufacturing
						company, oncology service provider, diagnostics and some Pharma
						initiatives like excipients etc.
					</Text>
				</Box>
				{/* Question 5 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						5. Can you share examples of successful investments Somerset Indus
						has made in the past, and how they have contributed to improving
						healthcare accessibility and affordability in India?
					</Heading>
					<Text variant="blogAnswer" py="16px" as="div">
						India 10 years back did not have ICU facilities beyond state
						capitals, our investment into{" "}
						<Text as="span" variant="blogQuestion" fontWeight="700">
							Sandor Medicads
						</Text>{" "}
						enabled Sandor to provide everything end to end (medical equipment
						and consumables) there by setting up ICU’s in tier2 and tier 3
						cities. This changed the position where care now was available
						closer.
						<br />
						<br />
						<UnorderedList>
							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Sandor Nephro,
									</Text>{" "}
									a network of dialysis delivery providers helped in dialysis
									centers being taken to tier 2 and tier 3 cities resulting in
									dialysis being available closer home, this enabled multiple
									chains both domestic and overseas to come and change the
									horizons of Indian healthcare in the renal care space.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Krsnaa Diagnostics
									</Text>{" "}
									which believed in the power of PPP, working together with the
									government to setup diagnostic centers all over the country
									and providing services at half the price charged by private
									players did not find any takers. But we invested, supported
									got in more investors built the company and finally took it
									public. It was a spectacular proof of the pudding.
								</Text>
							</ListItem>

							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Browndove
									</Text>{" "}
									was into dialysis space – consumable. Until Browndove came up,
									all the requirements were imported and the dialysis machine
									maker had a say in the consumable bought by the dialysis
									service provider. We invested to create a local manufacturing
									capability and offer products at a very affordable price.
									Today Browndove is a very valued and respected brand for its
									quality and price.
								</Text>
							</ListItem>

							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Prognosys
									</Text>{" "}
									was at a time when digital medical equipment was imported at
									very high cost and affordability existed only with the
									government. Prognosys enable manufacturing of digital x-ray
									and c-arm and totally changed the market with more and more
									private player in addition to government buying the products
									which was very high on quality and affordable on price.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Genworks,
									</Text>{" "}
									wherein the company focused on taking the best brands,
									technology coupled with connected care to tier II and tier III
									markets, was a game changer. The impact and the effect of
									taking healthcare to where the people deserved it the most,
									replacing pre-owned machines with new machines, opex model
									wherein you don’t pay for capex but pay for opex etc., changed
									the course of medtech, today from a capital equipment supplier
									to consumable supplier to a technology provider and finally a
									service provider in connected care is changing the phase of
									Indian healthcare system.
								</Text>
							</ListItem>

							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Apex hospital
									</Text>{" "}
									helped in healthcare moving from the state capital to district
									headquarters and Rajasthan proved a point where all the brands
									were concentrated in Jaipur and Apex hospital took healthcare
									beyond Jaipur and built hospitals in the district
									headquarters. Added to this it enabled tele –ICU services
									resulting in huge benefit to the patients including saving
									lives.
								</Text>
							</ListItem>

							<ListItem>
								<Text as="span" variant="blogQuestion" py="16px">
									<Text as="span" variant="blogQuestion" fontWeight="700">
										Sterling Hospital
									</Text>{" "}
									an oncology service providing hospital chain, again focused on
									interiors of Gujarat is making a difference to patients.
								</Text>
							</ListItem>
						</UnorderedList>
						<br />
						<br />
						One very important outcome of all these investments is availability
						of quality healthcare, coupled with technology at affordable cost in
						interior India.
					</Text>
				</Box>
				{/* Question 6 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						6. Given the evolving landscape of the Indian healthcare sector, how
						does Somerset Indus adapt its investment strategies to seize
						emerging opportunities and mitigate risks?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Healthcare luckily has been a robust sector and growing because of
						an increasing population requiring high quality care. Five years
						back healthcare was grossly underserved and available in capital
						cities only.
						<br />
						<br />
						Now healthcare is spreading beyond state capitals and this is
						helping rapid growth coupled with build-to-design hospital, leasing
						of brown field projects, Propco and Opco Business Models, Opex
						financing of medical equipment’s, technology both enterprise and
						business, increasing tele health facility, more and more medical
						equipment manufactured in India etc., are propelling growth.
						<br />
						<br />
						On the other side, global players are coming to Indian healthcare in
						a big way in acquiring, consolidating, aggregating healthcare to
						enable scale and size. This opportunity for mergers and acquisitions
						is growing rapidly and has attention of the global player.
						<br />
						<br />
						So looking at Somerset, it is very much aligned to the growing needs
						of the market and concentrating on both the opportunities and the
						possibilities of building more platforms resulting in them going
						public.
						<br />
						<br />
						Being conservative and cautious with an optimistic outlook, backed
						by very strong domain knowledge of the partners , picking and
						choosing promoters very carefully, sticking to a single vertical
						(healthcare) having investors supporting the initiatives and the
						partners actively involved in supporting promoters to realise their
						ambitions mitigates potential/possible risks
					</Text>
				</Box>
				{/* Question 7 */}
				<Box my="16px">
					<Heading variant="blogQuestion" pt="16px">
						7. Could you elaborate on Somerset Indus' approach to sustainable
						impact-based investing and its efforts to create positive
						environmental, social, and governance impacts?
					</Heading>
					<Text variant="blogAnswer" py="16px">
						Somerset is very much focused on ESG and all its confirmations are
						with international bodies like IFC, ADB, Morgan Stanley and Domestic
						investing institutions like NIIF among others. We are extremely
						compliant on ESG both from a fund and portfolio companies.
						<br />
						<br />
						One of the most important factors while investing is the potential
						impact each of the investment creates and benefits for both the
						society and the patients. Be in compliance, governance, statutory,
						approvals, permissions etc. there is a 100% adherence and
						compliance. Additionally be it equal opportunity, pollution, water,
						electricity, etc., etc., it is much focused to meet all requirements
						<br />
						<br />
						From a patient’s perspective the products and services make a
						difference in terms of the outcome, availability, accessibility and
						affordability. The portfolio companies work very closely with the
						Government and CSR partners including NGO’s to take healthcare
						closer to the customer. The latest technology resulting in connected
						care, products which can be operated by paramedics and the report
						generated from anywhere in the world, thanks to connected care is
						standing proof of success.
						<br />
						<br />
						Tele-Cardiology, Tele-Nephrology, Tele-NICU, Tele-ICU, Tele
						oncology, tele audiology etc., really help in the preventive care
						scenario where in patients are detected early and treated early
						saving huge amounts in the bargains. Somerset has also published
						reports on impact and sustainability where our portfolio companies
						are making a difference to mankind.{" "}
						<Link
							href={fileUrl}
							target="_blank"
							style={{
								textDecoration: "underline",
							}}
							rel="noreferrer"
						>
							Click here
						</Link>{" "}
						to access the recent report.
					</Text>
				</Box>
			</Box>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				The content in this section is curated by Team IVCA. For any feedback,
				connect with&nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default FundInFocusIndusHealth;
